<template>
  <div id="TrajectoryBox">
    <el-form class="trajectoryForm" label-width="70px" :model="formTrajectory" size="mini">
      <el-form-item label="选择车辆">
        <el-autocomplete
          class="inline-input"
          v-model="formTrajectory.deviceNo"
          :fetch-suggestions="querySearch"
          placeholder="请选择车辆"
          size="mini"
          @select="handleSelect"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="开始时间">
        <el-date-picker
          class="timePicker"
          v-model="formTrajectory.startTime"
          type="datetime"
          placeholder="选择日期时间"
          default-time="00:00:00"
          size="mini"
          @change="handleStartTimeChange"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker
          class="timePicker"
          v-model="formTrajectory.endTime"
          type="datetime"
          placeholder="选择日期时间"
          default-time="23:59:59"
          size="mini"
          @change="handleEndTimeChange"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <div class="btnBlock">
      <el-button class="btnItem" type="primary" size="mini" @click="checkPlyLocus(formTrajectory)">查询轨迹</el-button>
      <el-button class="btnItem" type="primary" size="mini" @click="backBiBaseLayer">返回</el-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { getMap } from '@/utils/mainMap2';
import carMarkerIcon from '@/assets/icon/car_icon.gif';
import carStartIcon from '@/assets/icon/startPoint.gif';
import carEndIcon from '@/assets/icon/endPoint.gif';
import { api } from '@/api';
import { Loading } from 'element-ui';

let globalLoading;

export default {
  name: "Trajectory",
  data() {
    return {
      labelPosition: 'right',
      formTrajectory: {
        deviceNo: '',
        endTime: '',
        startTime: ''
      },
      suggestions: null,
      polyline: null, // 轨迹线实例
      marker: null, // 巡航点实例
      cruiseInterval: null, // 巡航定时器
      startMarker: null,
      endMarker: null
    };
  },
  computed: {
    ...mapState('bi', ['querySearchData'])
  },
  mounted() {
    this.suggestions = this.querySearchData;
    this.map = getMap();
  },
  methods: {
    ...mapActions('bi', ['getPlyLocus']),
    querySearch(queryString, cb) {
      var queryDataList = this.suggestions;
      var results = queryString ? this.createFilter(queryDataList, queryString) : queryDataList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryDataList, queryString) {
      return queryDataList.filter((item) => item.value.toLowerCase().includes(queryString.toLowerCase()));
    },
    // 将所选时间转为时间戳
    convertToTimestamp(selecteDate) {
      if (selecteDate) {
        // 获取 13 位 Unix 毫秒时间戳
        const timestamp = selecteDate.getTime();
        return timestamp;
      } else {
        console.log("请先选择日期时间");
        return null;
      }
    },
    handleStartTimeChange() {
      this.formTrajectory.startTime = this.convertToTimestamp(this.formTrajectory.startTime);
    },
    handleEndTimeChange() {
      this.formTrajectory.endTime = this.convertToTimestamp(this.formTrajectory.endTime);
    },
    async checkPlyLocus({ deviceNo = null, carNo = null, returnCoord = 'GCJ-02', startTime, endTime }) {
      if (deviceNo && startTime && endTime) {
        if (!this.isWithin31Days(startTime, endTime)) {
          this.$message.warning('暂时只支持查询31天以内的数据');
          return false;
        }
        if (this.isStartGreaterEnd(startTime, endTime)) {
          this.$message.warning('开始时间不能大于结束时间');
          return false;
        }
        globalLoading = Loading.service({
          lock: true,
          text: '加载中...',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let res = await api.getPlyLocus({ deviceNo, carNo, returnCoord, startTime, endTime });
        if (res.code === 1) {
          globalLoading.close();
          const locusData = res.data;
          if (locusData.length === 0) {
            this.$message.error('暂无轨迹');
          } else {
            if (this.startMarker && this.endMarker) {
              window.mainMap.remove(this.startMarker);
              window.mainMap.remove(this.endMarker);
              this.startMarker = null;
              this.endMarker = null;
            }
            const result = locusData.map((subArray) => ([subArray.x, subArray.y]));
            this.drawPolyline(result);
          }
        }
      } else {
        await this.$msgbox('查询前请先完善查询条件', '', {
          confirmButtonText: '确定',
          showClose: false
        });
      }
    },
    handleSelect(item) {
      // console.log(item);
    },
    // 绘制轨迹线
    drawPolyline(path) {
      if (this.polyline) {
        this.map.remove(this.polyline); // 移除旧的轨迹线
      }
      // 创建新的轨迹线
      this.polyline = new AMap.Polyline({
        path: path,
        isOutline: true,
        outlineColor: '#ffeeee',
        borderWeight: 0.5,
        strokeWeight: 2,
        strokeOpacity: 0.9,
        strokeColor: '#15AD2E',
        lineJoin: 'round'
      });
      // 将轨迹线添加到地图
      this.map.add(this.polyline);
      // 调整地图视野以显示完整轨迹
      this.setMapViews(path);
      // 添加起始点、结束点marker
      this.addStarToEndMarder(path);
    },
    // 设置地图的显示范围
    setMapViews(path) {
      const markers = path.map(coord => new AMap.Marker({position: coord}));
      this.map.setFitView(markers);
    },
    // 添加起始点、结束点marker
    addStarToEndMarder(path) {
      const lastIndex = path.length - 1;
      const startMarker = new AMap.Marker({
          position: path[0],
          icon: new AMap.Icon({
            size: new AMap.Size(50, 50),
            image: carStartIcon,
            imageSize: new AMap.Size(20, 28)
          }),
          offset: new AMap.Pixel(-33, -30)
      });
      const endMarker = new AMap.Marker({
        position: path[lastIndex],
        icon: new AMap.Icon({
          size: new AMap.Size(50, 50),
          image: carEndIcon,
          imageSize: new AMap.Size(20, 28)
        }),
        offset: new AMap.Pixel(-33, -30)
      });
      this.startMarker = startMarker;
      this.endMarker = endMarker;
      window.mainMap.add(startMarker);
      window.mainMap.add(endMarker);
    },
    // 放回初始布局
    backBiBaseLayer() {
      if (this.polyline) {
        this.map.remove(this.polyline); // 移除轨迹线
      }
      if (this.startMarker && this.endMarker) {
        window.mainMap.remove(this.startMarker);
        window.mainMap.remove(this.endMarker);
        this.startMarker = null;
        this.endMarker = null;
      }
      this.$emit('showBaseLayer');
    },
    // 判断所选事件有无超过30天
    isWithin31Days(startTimestamp, endTimestamp) {
      // 1 天的毫秒数
      const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
      // 31 天的毫秒数
      const thirtyDaysInMilliseconds = 31 * oneDayInMilliseconds;
      // 计算时间差
      const timeDifference = endTimestamp - startTimestamp;
      // 判断是否超过 30 天
      if (timeDifference > thirtyDaysInMilliseconds) {
        return false; // 超出 30 天
      } else {
        return true; // 未超出 30 天
      }
    },
    isStartGreaterEnd(startTimestamp, endTimestamp) {
      if (startTimestamp > endTimestamp) {
        return true;
      } else {
        return false;
      }
    },
    destroy() {
      window.mainMap.remove(this.startMarker);
      window.mainMap.remove(this.endMarker);
      this.startMarker = null;
      this.endMarker = null;
    }
  }
};
</script>

<style lang="scss" scoped>
#TrajectoryBox {
  width: 300px;
  background-color: white;
  padding: 15px;
  border-radius: 5px;

  .trajectoryForm {
    width: 100%;

    .el-form-item {
      margin-bottom: 10px;

      .timePicker {
        width: 100%;
      }
    }

    .inline-input {
      width: 100%;
    }
  }

  .btnBlock {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    margin-top: 20px;

    .btnItem {
      width: 50%;
    }
  }
}
</style>
